<template>
  <VDialog width="600" v-model="show">
    <VCard>
      <VCardTitle class="mb-5">
        {{ $t('delete') }}
      </VCardTitle>
      <VCardSubtitle>
        {{ $t('label') }}
      </VCardSubtitle>
      <VCardText>
        <VSelect
          :items="options"
          item-text="name"
          item-value="id"
          solo
          v-model="newStatus"
        />
        <div class="text--primary mb-2">
          {{ $t('warning') }}
        </div>
        <VBtn @click="deleteStage">
          {{ $t('confirm') }}
        </VBtn>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'VacancyCandidatesKanbanStageDelete',
  props: {
    deletedStage: {
      type: Object,
      required: true,
    },
    value: {
      type: Boolean,
    },
    stages: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      newStatus: null,
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    options() {
      return this.stages.filter((s) => s.status !== this.deletedStage.status);
    },
  },
  mounted() {
    this.newStatus = this.options[0].id;
  },
  methods: {
    ...mapActions('kanban', ['delete']),
    async deleteStage() {
      await this.delete({ ...this.deletedStage, newStatusId: this.newStatus });
      this.$emit('input', false);
    },
  },
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yml">
  label: Choose new status for candidates from deleted status.
  confirm: Confirm
  delete: Delete status
  warning: The status will be removed in all vacancies!
</i18n>

<i18n locale="ru" lang="yml">
  label: Выберите статус, в которые нужно переместить кандидатов из удаляемого статуса.
  confirm: Подтвердить
  delete: Удаление статуса
  warning: Cтатус удалится во всех вакансиях!
</i18n>
